module.exports = __webpack_public_path__ + "static/media/kerstman-red-velvet-2.48f63bfe.jpeg";